module.exports = __webpack_public_path__ + "static/media/Kristalina_mobile.26aeac26.jpg";